//
//
//
//
//
//
//
//
//
//

export default {
    props: ['widget'],
    computed: {
        colors() {
            try {
                switch (this.widget.fields.background) {
                    case 'Dark':
                        return 'bg-[#2D3D47] text-white';
                    case 'Info':
                        return 'bg-info text-white';
                    case 'Orange':
                        return 'bg-[#EC6D46] text-white';
                    case 'Light Blue Accent':
                        return 'bg-[#43A3A0] text-white';
                    default:
                        return 'bg-info text-white';
                }
            } catch (e) {
                return 'bg-info text-white';
            }
        },
    },
};
